import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-153e7b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 2,
  class: "pagination__gap"
}
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = {
  key: 3,
  class: "pagination__gap"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePagination',
  props: {
    disabled: { type: Boolean, default: false },
    length: {},
    totalVisible: {},
    modelValue: { default: 1 },
    showFirstLast: { type: Boolean, default: false },
    showPrevNext: { type: Boolean, default: false },
    style: { default: 'base' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visiblePages = computed<number[]>(() => {
  if (props.totalVisible === undefined) return [];

  let startPage: number;
  let endPage: number;

  if (!Number.isInteger(props.totalVisible) || props.length <= props.totalVisible) {
    startPage = 1;
    endPage = props.length;
  } else {
    const pagesBeforeCurrentPage = Math.floor(props.totalVisible / 2);
    const pagesAfterCurrentPage = Math.ceil(props.totalVisible / 2) - 1;

    if (props.modelValue <= pagesBeforeCurrentPage) {
      startPage = 1;
      endPage = props.totalVisible;
    } else if (props.modelValue + pagesAfterCurrentPage >= props.length) {
      startPage = props.length - props.totalVisible + 1;
      endPage = props.length;
    } else {
      startPage = props.modelValue - pagesBeforeCurrentPage;
      endPage = props.modelValue + pagesAfterCurrentPage;
    }
  }

  return Array.from(Array(endPage + 1 - startPage).keys()).map(i => startPage + i);
});

const changePage = (pageNumber: number) => {
  emit('update:modelValue', pageNumber);
};

const toPrev = () => {
  changePage(props.modelValue - 1);
};

function toNext() {
  changePage(props.modelValue + 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([_ctx.style, "pagination__button start"]),
      disabled: _ctx.disabled || _ctx.modelValue === 1,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(1)))
    }, " В начало ", 10, _hoisted_2),
    (_ctx.showPrevNext)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass([_ctx.style, "pagination__button"]),
          disabled: _ctx.disabled || _ctx.modelValue === 1,
          onClick: toPrev
        }, " < ", 10, _hoisted_3))
      : _createCommentVNode("", true),
    (
        _ctx.showFirstLast &&
        _ctx.totalVisible &&
        _ctx.modelValue > Math.ceil(_ctx.totalVisible / 2) + 1 &&
        _ctx.length > _ctx.totalVisible
      )
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass([_ctx.style, "pagination__button"]),
          disabled: _ctx.disabled,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(1)))
        }, " 1 ", 10, _hoisted_4))
      : _createCommentVNode("", true),
    (
        _ctx.showFirstLast &&
        _ctx.totalVisible &&
        _ctx.modelValue > Math.ceil(_ctx.totalVisible / 2) + 1 &&
        _ctx.length > _ctx.totalVisible + 1
      )
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ... "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
      return (_openBlock(), _createElementBlock("button", {
        key: page,
        class: _normalizeClass([{ active: _ctx.modelValue === page, simple: _ctx.style === 'simple' }, "pagination__button"]),
        disabled: _ctx.disabled,
        onClick: ($event: any) => (changePage(page))
      }, _toDisplayString(page), 11, _hoisted_6))
    }), 128)),
    (
        _ctx.showFirstLast &&
        _ctx.totalVisible &&
        _ctx.modelValue < _ctx.length - Math.ceil(_ctx.totalVisible / 2) &&
        _ctx.length > _ctx.totalVisible + 1
      )
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " ... "))
      : _createCommentVNode("", true),
    (
        _ctx.showFirstLast &&
        _ctx.totalVisible &&
        _ctx.modelValue <= _ctx.length - Math.ceil(_ctx.totalVisible / 2) &&
        _ctx.length > _ctx.totalVisible
      )
      ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          class: _normalizeClass([{ active: _ctx.modelValue === _ctx.length, simple: _ctx.style === 'simple' }, "pagination__button"]),
          disabled: _ctx.disabled,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(_ctx.length)))
        }, _toDisplayString(_ctx.length), 11, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.showPrevNext)
      ? (_openBlock(), _createElementBlock("button", {
          key: 5,
          class: _normalizeClass([_ctx.style, "pagination__button"]),
          disabled: _ctx.disabled || _ctx.modelValue === _ctx.length,
          onClick: toNext
        }, " > ", 10, _hoisted_9))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: _normalizeClass([_ctx.style, "pagination__button end"]),
      disabled: _ctx.disabled || _ctx.modelValue === _ctx.length,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(_ctx.length)))
    }, " В конец ", 10, _hoisted_10)
  ]))
}
}

})